import deserializeQueryStringItem from '@/helpers/deserializeQueryStringItem';
import { type QueryStringItem } from '@/helpers/deserializeQueryStringItem/typings';

type Input = {
  returnToOverride?: string | null;
  returnToQuery: QueryStringItem;
  routerIsReady: boolean;
  routerPathname: string;
  routerAsPath: string;
  allowCurrentPathFallback?: boolean;
};

/**
 * Resolves a safe returnTo path for auth redirects based on query params or the current path.
 */
const getReturnToFromRouter = ({
  returnToOverride,
  returnToQuery,
  routerIsReady,
  routerPathname,
  routerAsPath,
  allowCurrentPathFallback = true,
}: Input): string | null => {
  if (returnToOverride) {
    return returnToOverride;
  }

  const returnToFromQuery = deserializeQueryStringItem(returnToQuery, { type: 'string' });
  if (returnToFromQuery) {
    return returnToFromQuery;
  }

  if (!allowCurrentPathFallback || !routerIsReady) {
    return null;
  }

  if (routerPathname.startsWith('/auth')) {
    return null;
  }

  return routerAsPath;
};

export default getReturnToFromRouter;
